import type { ReactNode } from 'react';
import './StatTile.css';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  /** One short line of context under the value. */
  detail?: ReactNode;
  /** Draws attention without relying on colour alone — pair with an icon. */
  tone?: 'default' | 'warning';
}

/**
 * A single number that needs no chart.
 *
 * Grouped and named so a screen reader reads "Rows: 1,204" as one fact, rather
 * than two loose pieces of text that happen to sit near each other.
 */
export function StatTile({ label, value, detail, tone = 'default' }: StatTileProps) {
  return (
    <div
      className={`sc-stat sc-stat--${tone}`}
      role="group"
      aria-label={`${label}: ${String(value)}${detail ? `, ${String(detail)}` : ''}`}
    >
      <span className="sc-stat__label">{label}</span>
      <span className="sc-stat__value sc-numeric">{value}</span>
      {detail && <span className="sc-stat__detail">{detail}</span>}
    </div>
  );
}
